import LuxRooms from "../assets/portfolio/LuxRooms.jpg"
import OnlineShopping from "../assets/portfolio/OnlineShopping.PNG"
import QA from "../assets/portfolio/QA.PNG"
import Invoice from "../assets/portfolio/invoice.PNG"
import FRTApp from "../assets/portfolio/FRTApp.PNG"
import HDPredictor from "../assets/portfolio/HDPredictor.PNG"

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    img: OnlineShopping,
    title: "ONLINE SHOPPING APP",
    desc: "An online shopping site, a companion for your online shoppers that makes it easier to find the products and brands that they want!",
    demo: "https://aid-consults.netlify.app/",
    source: "https://github.com/ayomideEnoch/aid-consults",
  },
  {
    img: QA,
    title: "QUESTION AND ANSWER APP",
    desc: "A web based game that allows audiences to answer questions and review their performance at the end of the game!",
    demo: "https://q-a.netlify.app/",
    source: "https://github.com/ayomideEnoch/q-a-app",
  },
  {
    img: LuxRooms,
    title: "LUXURIOUS ROOMS",
    desc: "A React E-commerce PWA that allows you select your room of choice, depending on size and other preferences!",
    demo: "https://luxurious-rooms.netlify.app/",
    source: "https://github.com/ayomideEnoch/luxurious-rooms",
  },
  {
    img: FRTApp,
    title: "FLIGHT REALTIME INFO APP",
    desc: "An app that shows realtime info of flights around the world! \n For demo, input email: demo@demo.com and password: demodemo!",
    demo: "https://opensky-coven-works.netlify.app/",
    source: "https://github.com/ayomideEnoch/Coven-Works",
  },
  {
    img: Invoice,
    title: "INVOICE APP",
    desc: "A simple invoicing software that gives invoice details with payment status and printing options. Save time, stay organized and look professional!",
    demo: "https://invoice-web.netlify.app/",
    source: "https://github.com/ayomideEnoch/invoice-app",
  },
  {
    img: HDPredictor,
    title: "HEART DISEASE PREDICTOR",
    desc: "Machine Learning project to predict heart diseases. Predicting chance of heart disease in people using Regression and Decision Tree algorithms. Ongoing...",
    demo: "https://github.com/ayomideEnoch/heart-disease-predictor",
    source: "https://github.com/ayomideEnoch/heart-disease-predictor",
  },
]
